import { Inject, Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
} from "@fpx/core";
import { map } from "rxjs";
import { TransfersfilterService } from '../transfersfilter-service/transfersfilter.service';
import { Transfersfilter } from '../transfersfilter-service/transfersfilter.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import moment from "moment";
import { TransfersMainService } from "../services/transfers-main.service";
import { CommonService } from "src/app/common.service";



export class TransfersFilterFormState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
   fromMinDate: any;
   toMinDate: any;
   maxDate: any;
   instructionType:string;
}


@Injectable()
export class TransfersFilterFormHelper extends BaseFpxFormHelper<TransfersFilterFormState>{

   constructor(@Inject(MAT_DIALOG_DATA) private data: IPopupScreenData,    private commonservice: CommonService,private transfersFilterFormService: TransfersfilterService,private _transfersMainService: TransfersMainService)
    {
        super(new TransfersFilterFormState());
    }

  override doPreInit(): void {
	this.addValueChangeHandler("fromDate", this.handleFromDateOnvalueChange);
	this.addValueChangeHandler("toDate", this.handleToDateOnvalueChange);
  }

  public override doPostInit(): void {
    
    this.state.instructionType = this.data?.screenData?.instructionType;
    console.log('this.instructionType',this.state.instructionType)
    if(this.state.instructionType === 'P'){
      this.state.fromMinDate = this.subtractYears(1);
      this.state.maxDate = new Date(this.commonservice.serverDate);
    }else{
      this.state.fromMinDate = moment();
      this.state.maxDate =  this.addMonth(1);
    }
    let transfersFilterData = this._transfersMainService.transfersFilterData;
    if(transfersFilterData){
      this.formGroup.controls["fromDate"].patchValue(transfersFilterData.fromDate);
      setTimeout(() => {
        this.formGroup.controls["toDate"].patchValue(transfersFilterData.toDate);
      }, 400);
    }


  }

private handleFromDateOnvalueChange: BaseFpxChangeHandler = (
		name: string,
		status: FormControlStatus,
		value: any,
		formGroup: FormGroup
		) => {
		   // WRITE CODE HERE TO HANDLE
       if (value) {
        this.state.fromMinDate = this.subtractYears(1);
        value = new Date(value);
        this.state.toMinDate = value;
        formGroup.controls["toDate"].enable();
        formGroup.controls["toDate"].reset();
      }
}
private handleToDateOnvalueChange: BaseFpxChangeHandler = (
		name: string,
		status: FormControlStatus,
		value: any,
		formGroup: FormGroup
		) => {
		   // WRITE CODE HERE TO HANDLE
}
subtractYears(numOfYears, date = new Date()) {
  date.setFullYear(date.getFullYear() - numOfYears);
  return date;
}
 
addMonth(Date){
  // date.setFullYear(date.getM() - numOfYears);
  console.log(" this._transfersMainService.getminAndMaxDate(1,'M')", this._transfersMainService.getminAndMaxDate(1,'M'))
  return this._transfersMainService.getminAndMaxDate(1,'M')
}

  public override preSubmitInterceptor(payload: Transfersfilter):any {
     // WRITE CODE HERE TO HANDLE
    
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    // routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
 //$START_CUSTOMSCRIPT\n
 //$END_CUSTOMSCRIPT\n
}
